import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';
import { ScreensQuestionResource } from '@Components/mras/core';
import { SharedModule } from '@Shared/shared.module';

@Component({
    selector: 'jhi-boolean-input',
    templateUrl: './boolean-input.component.html',
    imports: [SharedModule]
})
export class BooleanInputComponent implements OnChanges {
    @Input()
        question: ScreensQuestionResource;
    @Input()
        summaryMode: boolean;
    @Input()
        value: any;

    _valueText: string;
    @Input()
    set valueText(val: string) {
        if (val?.toString() === 'true' || val === 'Yes') {
            this._valueText='Yes';
        } 
        else if (val?.toString() === 'false' || val === 'No') {
            this._valueText='No';
        }else{
            this._valueText = val;
        }
    }
    get valueText() { return this._valueText; }
    @Output()
        valueChange = new EventEmitter<any>();
    @Output()
        action = new EventEmitter<any>();
    @Input()
        nullable = true;

    constructor() {}

    private toBoolean(value: any): boolean | null {
        if (value === true || value === 'true' || value === 'Yes') {
            return true;
        }

        if (value === false || value === 'false' || value === 'No') {
            return false;
        }

        return null;
    }

    ngOnChanges(changes: SimpleChanges): void {
        if (changes.value) {
            const normalizedValue = this.toBoolean(this.value);
            this.value = normalizedValue;
            if (this.value === null && changes.value.firstChange) {
                this.value = this.toBoolean(this._valueText);
            }
        }
    }

    onClick(value: boolean) {        
        if (this.question.invalid) {
            this.question.invalid = false;
        }
        
        const answerHasChanged = this.toBoolean(this.value) !== value;

        this.value = value;
        this.valueChange.emit(this.value);
        this.action.emit(answerHasChanged);
    }

}
